import React from 'react';

export const Letter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.672 5.172C2.5 6.343 2.5 8.229 2.5 12C2.5 15.771 2.5 17.657 3.672 18.828C4.843 20 6.729 20 10.5 20H14.5C18.271 20 20.157 20 21.328 18.828C22.5 17.657 22.5 15.771 22.5 12C22.5 8.229 22.5 6.343 21.328 5.172C20.157 4 18.271 4 14.5 4H10.5C6.729 4 4.843 4 3.672 5.172ZM19.076 7.52C19.2032 7.67279 19.2646 7.86985 19.2466 8.06787C19.2286 8.26589 19.1327 8.44866 18.98 8.576L16.784 10.406C15.897 11.146 15.179 11.744 14.544 12.152C13.884 12.577 13.241 12.845 12.5 12.845C11.759 12.845 11.116 12.576 10.455 12.152C9.821 11.744 9.103 11.145 8.216 10.407L6.02 8.577C5.8671 8.4497 5.77104 8.26687 5.75294 8.06874C5.73484 7.8706 5.7962 7.6734 5.9235 7.5205C6.0508 7.3676 6.23363 7.27154 6.43176 7.25344C6.6299 7.23534 6.8271 7.2967 6.98 7.424L9.14 9.223C10.073 10 10.72 10.538 11.268 10.89C11.797 11.23 12.156 11.345 12.501 11.345C12.846 11.345 13.205 11.231 13.734 10.89C14.281 10.538 14.929 10 15.862 9.223L18.021 7.423C18.1739 7.29587 18.3711 7.23467 18.5691 7.25286C18.7671 7.27105 18.9488 7.36714 19.076 7.52Z"
      fill="currentColor"
    />
  </svg>
);
